/* eslint-disable react/prop-types */

import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import "bootstrap/dist/css/bootstrap.min.css";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftSnackbar from "components/SoftSnackbar";
import FormField from "layouts/pages/account/components/FormField";
import selectData from "./data/selectData";
import UploadButton from "../UploadButton";
import { getDepartments } from "api/departments";
import { getDesignations } from "api/designation";
import { getBranches } from "api/branches";
import { getRoles } from "api/roles";
// import {
//   getManagersByBranch,
//   getShiftsByBranch,
//   getTeamLeadersByBranchAndShift,
// } from "api/branches";
import {
  getManagersByBranch,
  getTeamLeadersByBranchAndShift,
} from "api/branches";

import {
  getSubBranchesByBranch,
  getShiftsBySubBranch,
} from "api/subBranches";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URL } from "config";
import { useAuth } from "AuthContext";
import { useMemo } from "react";
import { roleAllowsMultipleShifts } from "utils/accessRole";

// Import Dialog components from MUI
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";

// Import icons for different file types
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from "@mui/icons-material/Image";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import ArticleIcon from "@mui/icons-material/Article";

const API_CALL_GAP_MS = 150;
const waitBetweenApiCalls = () => new Promise((resolve) => setTimeout(resolve, API_CALL_GAP_MS));
const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;

  if (data?.errors && typeof data.errors === "object") {
    return Object.entries(data.errors)
      .map(([field, messages]) => {
        const text = Array.isArray(messages) ? messages.join(", ") : messages;
        return `${field}: ${text}`;
      })
      .join("; ");
  }

  return data?.message || data?.error || error?.message || fallback;
};

function BasicInfo({ value = {}, onChange, onUpdate }) {
  /* ================= PERMISSIONS ================= */
  const { permissions: ctxPerms = [] } = useAuth();

  const storedPerms = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]");
    } catch {
      return [];
    }
  }, []);

  const permSet = useMemo(() => {
    const perms = ctxPerms.length ? ctxPerms : storedPerms;
    return new Set(perms.map((p) => (typeof p === "string" ? p : p.name)));
  }, [ctxPerms, storedPerms]);

  const canView = (key) => permSet.has(`UserProfile.BasicInfo.${key}`);
  const canSection = permSet.has("UserProfile.BasicInfo");

  const { id } = useParams();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "success",
  });

  const [requiredErrors, setRequiredErrors] = useState([]);

  // Confirmation Dialog State
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "Confirm Update",
    message: "Are you sure you want to update the basic information?",
  });

  const [formData, setFormData] = useState({
    name: "",
    last_name: "",
    dob: "",
    email: "",
    phone_number: "",
    emergency_contact_one: "",
    emergency_contact_two: "",
    location: "",
    current_address: "",
    permanent_address: "",
    aadhar_number: "",
    pan_number: "",
    relocate: "",
    referrer_name: "",
    qualification: "",
    employment_status: "",
    department_id: "",
    designation_id: "",
    exp_years: "",
    exp_months: "",
    notice_period: "",
    salary_current: "",
    salary_expected: "",
    role_id: "",
    branch_id: "",
    subbranch_id: "",
    manager_id: "",
    team_leader_id: "",
    pf: "",
    esi: "",

    shifts: [],
    shift_id: null,
    gender: "",
    photo: "",
    user_code: "",
    cv: "",
    consent_form: "",
  });

  const booleanOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  const [dropdowns, setDropdowns] = useState({
    department: [],
    designation: [],
    branches: [],
    subBranches: [],
    roles: [],
    branchManagers: [],
    branchShifts: [],
    teamLeaders: [],
  });
  const [emailError, setEmailError] = useState("");
  const [isMultiShift, setIsMultiShift] = useState(false);

  const [loading, setLoading] = useState({
    initial: true,
    branch: false,
    teamLeaders: false,
    updating: false,
  });
  const selectedRole =
    dropdowns?.roles?.find((r) => r.value === formData.role_id)?.label?.toLowerCase() || "";

  // Enhanced helper function to check file type with more specific detection
  const getFileTypeDetails = (file) => {
    if (!file)
      return { type: "none", icon: InsertDriveFileIcon, color: "#757575", label: "No file" };

    let fileName = "";
    let fileType = "";

    if (typeof file === "string") {
      // If it's already a URL string
      fileName = file.split("/").pop().toLowerCase();
      fileType = "url";
    } else if (file instanceof File) {
      fileName = file.name.toLowerCase();
      fileType = file.type;
    } else {
      return { type: "other", icon: InsertDriveFileIcon, color: "#757575", label: "File" };
    }

    // Get file extension
    const extension = fileName.split(".").pop();

    // Check for specific file types
    if (extension === "pdf" || fileName.includes(".pdf") || fileType === "application/pdf") {
      return {
        type: "pdf",
        icon: PictureAsPdfIcon,
        color: "#d32f2f",
        label: "PDF Document",
        acceptColor: "#d32f2f",
      };
    } else if (
      extension === "doc" ||
      fileType.includes("msword") ||
      fileType.includes("wordprocessing")
    ) {
      return {
        type: "doc",
        icon: ArticleIcon,
        color: "#2b579a",
        label: "Word Document",
        acceptColor: "#2b579a",
      };
    } else if (
      extension === "docx" ||
      fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return {
        type: "docx",
        icon: ArticleIcon,
        color: "#2b579a",
        label: "Word Document",
        acceptColor: "#2b579a",
      };
    } else if (extension === "txt" || fileType === "text/plain") {
      return {
        type: "txt",
        icon: TextSnippetIcon,
        color: "#4caf50",
        label: "Text File",
        acceptColor: "#4caf50",
      };
    } else if (extension === "rtf" || fileType === "application/rtf") {
      return {
        type: "rtf",
        icon: DescriptionIcon,
        color: "#ff9800",
        label: "Rich Text File",
        acceptColor: "#ff9800",
      };
    } else if (
      ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(extension) ||
      fileType.includes("image/")
    ) {
      return {
        type: "image",
        icon: ImageIcon,
        color: "#9c27b0",
        label: "Image",
        acceptColor: "#9c27b0",
      };
    } else if (
      extension === "xls" ||
      extension === "xlsx" ||
      fileType.includes("excel") ||
      fileType.includes("spreadsheet")
    ) {
      return {
        type: "excel",
        icon: ArticleIcon,
        color: "#217346",
        label: "Excel File",
        acceptColor: "#217346",
      };
    } else if (
      extension === "ppt" ||
      extension === "pptx" ||
      fileType.includes("powerpoint") ||
      fileType.includes("presentation")
    ) {
      return {
        type: "ppt",
        icon: ArticleIcon,
        color: "#d24726",
        label: "PowerPoint",
        acceptColor: "#d24726",
      };
    } else {
      return {
        type: "other",
        icon: InsertDriveFileIcon,
        color: "#757575",
        label: "Document",
        acceptColor: "#757575",
      };
    }
  };

  // Helper function to get file URL
  const getFileUrl = (file) => {
    if (!file) return null;
    if (typeof file === "string") {
      // If it's already a URL string
      return file.startsWith("http") ? file : `${API_URL}${file}`;
    }
    if (file instanceof File) {
      return URL.createObjectURL(file);
    }
    return null;
  };

  // Helper function to get file name
  const getFileName = (file, fallbackUrl) => {
    if (!file) {
      if (fallbackUrl) {
        return fallbackUrl.split("/").pop() || "File";
      }
      return "";
    }
    if (typeof file === "string") {
      return file.split("/").pop() || "File";
    }
    return file.name || "File";
  };

  // Cleanup object URLs on unmount
  useEffect(() => {
    return () => {
      // Cleanup any object URLs
      if (formData.cv instanceof File) {
        const url = getFileUrl(formData.cv);
        if (url && url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      }
      if (formData.photo instanceof File) {
        const url = getFileUrl(formData.photo);
        if (url && url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      }
    };
  }, [formData.cv, formData.photo]);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const departmentsRes = await getDepartments(1, 250);
        await waitBetweenApiCalls();
        const designationsRes = await getDesignations(1, 250);
        await waitBetweenApiCalls();
        const branchesRes = await getBranches(1, 250);
        await waitBetweenApiCalls();
        const rolesRes = await getRoles(1, 250);

        setDropdowns((prev) => ({
          ...prev,
          department: Array.isArray(departmentsRes?.data)
            ? departmentsRes.data.map((d) => ({ label: d.name, value: d.id }))
            : [],
          designation: Array.isArray(designationsRes?.data)
            ? designationsRes.data.map((d) => ({ label: d.name, value: d.id }))
            : [],
          branches: Array.isArray(branchesRes?.data)
            ? branchesRes.data.map((b) => ({ label: b.name, value: b.id }))
            : [],
          roles: Array.isArray(rolesRes?.roles)
            ? rolesRes.roles.map((r) => ({
                label: r.name,
                value: r.id,
                user_scope: r.user_scope,
                scopes: r.scopes || [],
              }))
            : [],
        }));
        // if (value) {
        //   const formattedShifts = value.shifts
        //     ? Array.isArray(value.shifts)
        //       ? value.shifts.map((s) => s.id)
        //       : []
        //     : [];
        //   setFormData((prev) => ({
        //     ...prev,
        //     ...value,
        //     shifts: formattedShifts,
        //     shift_id:
        //       value.shift_id ||
        //       (Array.isArray(value.shifts) && value.shifts.length > 0 ? value.shifts[0].id : null),
        //   }));
        // }
        if (value) {
          const formattedShifts = value.shifts
            ? Array.isArray(value.shifts)
              ? value.shifts.map((s) => s.id)
              : []
            : [];

          setFormData((prev) => ({
            ...prev,
            ...value,
            shifts: formattedShifts,

            // 🔥 ADD THESE 3 LINES
            subbranch_id: value?.subbranch_id || "",
            // manager_id: value?.manager_id || "",
            manager_id: prev.manager_id || value?.manager_id || "",
            shift_id:
              value?.shift_id ||
              (Array.isArray(value?.shifts) && value.shifts.length > 0
                ? value.shifts[0].id
                : null),
          }));
        }
      } catch (error) {
        console.error("Error loading initial data:", error);
      } finally {
        setLoading((prev) => ({ ...prev, initial: false }));
      }
    };
    loadInitialData();
  }, [value]);

  // ... (rest of your useEffect hooks remain the same)

  // useEffect(() => {
  //   const loadBranchData = async () => {
  //     if (!formData.branch_id) {
  //       setDropdowns((prev) => ({
  //         ...prev,
  //         branchManagers: [],
  //          branchShifts: [],
  //         teamLeaders: [],
  //       }));
  //       setFormData((prev) => ({
  //         ...prev,
  //         manager_id: "",
  //         team_leader_id: "",
  //          shifts: [],
  //          shift_id: null,
  //       }));
  //       return;
  //     }
  //     setLoading((prev) => ({ ...prev, branch: true }));
  //     try {
  //       const [managersRes, shiftsRes] = await Promise.all([
  //         getManagersByBranch(formData.branch_id),
  //         // getShiftsByBranch(formData.branch_id),
  //       ]);
  //       const managers = Array.isArray(managersRes?.data)
  //         ? managersRes.data
  //         : Array.isArray(managersRes)
  //           ? managersRes
  //           : [];
  //       const shifts = Array.isArray(shiftsRes?.data)
  //         ? shiftsRes.data
  //         : Array.isArray(shiftsRes?.shifts)
  //           ? shiftsRes.shifts
  //           : Array.isArray(shiftsRes)
  //             ? shiftsRes
  //             : [];
  //       setDropdowns((prev) => ({
  //         ...prev,
  //         branchManagers: managers.map((m) => ({
  //           label: m.name || `${m.first_name || ""} ${m.last_name || ""}`.trim(),
  //           value: m.id,
  //         })),
  //         branchShifts: shifts.map((s) => ({
  //           label: `${s.type} (${s.shift_code} ${s.start_time}-${s.end_time})`,
  //           value: s.id,
  //         })),
  //       }));
  //       if (value?.shifts) {
  //         const shiftIds = Array.isArray(value.shifts) ? value.shifts.map((s) => s.id) : [];
  //         setFormData((prev) => ({
  //           ...prev,
  //           shifts: shiftIds,
  //           shift_id: shiftIds.length > 0 ? shiftIds[0] : null,
  //         }));
  //       }
  //     } catch (error) {
  //       console.error("Error loading branch data:", error);
  //     } finally {
  //       setLoading((prev) => ({ ...prev, branch: false }));
  //     }
  //   };
  //   loadBranchData();
  // }, [formData.branch_id, value]);

  useEffect(() => {
    const loadBranchData = async () => {
      if (!formData.branch_id) return;

      try {
        const res = await getSubBranchesByBranch(formData.branch_id);
        const subBranches = Array.isArray(res?.data) ? res.data : Array.isArray(res?.subbranches) ? res.subbranches : Array.isArray(res) ? res : [];

        await waitBetweenApiCalls();
        const managersRes = await getManagersByBranch(formData.branch_id);
        const managers = Array.isArray(managersRes?.data) ? managersRes.data : Array.isArray(managersRes?.managers) ? managersRes.managers : Array.isArray(managersRes) ? managersRes : [];

        setDropdowns(prev => ({
          ...prev,
          subBranches: subBranches.map(sb => ({
            label: sb.name,
            value: sb.id,
          })),
          branchManagers: managers.map(m => ({
            label: m.name,
            value: m.id,
          })),
        }));

        // ✅🔥 ADD THIS BLOCK
        setFormData(prev => ({
          ...prev,
          subbranch_id: formData.branch_id === value?.branch_id ? (prev.subbranch_id || value?.subbranch_id || "") : prev.subbranch_id,
          manager_id: formData.branch_id === value?.branch_id ? (prev.manager_id || value?.manager_id || "") : prev.manager_id,
        }));

      } catch (err) {
        console.error(err);
      }
    };

    loadBranchData();
  }, [formData.branch_id]);

  // useEffect(() => {
  //   const loadShifts = async () => {
  //     if (!formData.subbranch_id) {
  //       setDropdowns(prev => ({
  //         ...prev,
  //         branchShifts: [],
  //       }));
  //       return;
  //     }

  //     try {
  //       const res = await getShiftsBySubBranch(formData.subbranch_id);
  //       const shifts = res.data || [];

  //       setDropdowns(prev => ({
  //         ...prev,
  //         branchShifts: shifts.map(s => ({
  //           label: `${s.start_time} - ${s.end_time}`,
  //           value: s.id,
  //         })),
  //       }));

  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   loadShifts();
  // }, [formData.subbranch_id]);

  useEffect(() => {
    const loadShifts = async () => {
      if (!formData.subbranch_id) return;

      try {
        const res = await getShiftsBySubBranch(formData.subbranch_id);
        const shifts = Array.isArray(res?.data) ? res.data : Array.isArray(res?.shifts) ? res.shifts : Array.isArray(res) ? res : [];

        setDropdowns(prev => ({
          ...prev,
          branchShifts: shifts.map(s => ({
            label: `${s.start_time} - ${s.end_time}`,
            value: s.id,
          })),
        }));

        // ✅🔥 ADD THIS
        if (formData.subbranch_id === value?.subbranch_id && value?.shifts?.length && !formData.shift_id) {
          setFormData(prev => ({
            ...prev,
            shift_id: value.shifts[0].id,
          }));
        }

      } catch (err) {
        console.error(err);
      }
    };

    loadShifts();
  }, [formData.subbranch_id]);

  useEffect(() => {
    const loadTeamLeaders = async () => {
      if (!formData.branch_id || !formData.shift_id) {
        setDropdowns((prev) => ({ ...prev, teamLeaders: [] }));
        setFormData((prev) => ({ ...prev, team_leader_id: "" }));
        return;
      }
      setLoading((prev) => ({ ...prev, teamLeaders: true }));
      try {
        const response = await getTeamLeadersByBranchAndShift(
          formData.branch_id,
          formData.shift_id
        );
        const teamLeaders = Array.isArray(response?.data) ? response.data : Array.isArray(response?.team_leaders) ? response.team_leaders : Array.isArray(response) ? response : [];
        setDropdowns((prev) => ({
          ...prev,
          teamLeaders: teamLeaders.map((tl) => ({
            label: tl.name || "Unknown",
            value: tl.id,
          })),
        }));
        const valShiftId = value?.shift_id || (value?.shifts?.length > 0 ? value.shifts[0].id : null);
        if (value?.team_leader_id && Number(formData.branch_id) === Number(value?.branch_id) && Number(formData.shift_id) === Number(valShiftId)) {
          const validTeamLeader = teamLeaders.some((tl) => Number(tl.id) === Number(value.team_leader_id));
          if (validTeamLeader) {
            setFormData((prev) => ({ ...prev, team_leader_id: prev.team_leader_id || value.team_leader_id }));
          }
        }
      } catch (error) {
        console.error("Error loading team leaders:", error);
        setDropdowns((prev) => ({ ...prev, teamLeaders: [] }));
      } finally {
        setLoading((prev) => ({ ...prev, teamLeaders: false }));
      }
    };
    loadTeamLeaders();
  }, [formData.branch_id, formData.shift_id, value?.team_leader_id]);

  useEffect(() => {
    if (!formData.role_id) {
      setIsMultiShift(false);
      return;
    }
    const role = dropdowns.roles.find((r) => r.value === formData.role_id);
    setIsMultiShift(roleAllowsMultipleShifts(role));
  }, [formData.role_id, dropdowns.roles]);

  useEffect(() => {
    if (onChange) onChange(formData);
  }, [formData, onChange]);

  const handleInputChange = (field) => (e) => {
    const val = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: val }));
    if (field === "email") {
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
      setEmailError(isValid ? "" : "Please enter a valid email address.");
    }
  };

  const handleSelectChange = (field) => (option) => {
    setFormData((prev) => ({ ...prev, [field]: option?.value || "" }));
  };

  const handleMultiSelectChange = (field) => (options) => {
    setFormData((prev) => ({
      ...prev,
      [field]: options ? options.map((opt) => opt.value) : [],
    }));
  };

  const handleExperienceChange = (field) => (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (field) => (file) => {
    // Cleanup previous object URL if exists
    if (formData[field] instanceof File) {
      const oldUrl = getFileUrl(formData[field]);
      if (oldUrl && oldUrl.startsWith("blob:")) {
        URL.revokeObjectURL(oldUrl);
      }
    }

    console.log(file);

    setFormData((prev) => ({ ...prev, [field]: file }));
  };

  // Show confirmation dialog
  // const showConfirmationDialog = () => {
  //   setConfirmDialog({
  //     open: true,
  //     title: "Confirm Update",
  //     message: "Are you sure you want to update the basic information? This will save all changes made to the form.",
  //   });
  // };

  const showConfirmationDialog = () => {
    const errors = [];

    if (!formData.role_id) errors.push("Role");
    if (!formData.branch_id) errors.push("Branch");
    if (!formData.designation_id) errors.push("Designation");

    if (isMultiShift) {
      if (!formData.shifts || formData.shifts.length === 0) {
        errors.push("At least one Shift");
      }
    } else {
      if (!formData.shift_id) {
        errors.push("Shift");
      }
    }

    if (errors.length > 0) {
      setRequiredErrors(errors);
      setSnackbar({
        open: true,
        message: `Please fill the following required fields: ${errors.join(", ")}`,
        color: "warning",
      });
      return; // ❌ dialog open nahi hoga
    }

    // ✅ sab valid hai to error clear + dialog open
    setRequiredErrors([]);
    setConfirmDialog({
      open: true,
      title: "Confirm Update",
      message: "Are you sure you want to update the basic information?",
    });
  };

  // Handle cancel action
  const handleCancelUpdate = () => {
    setConfirmDialog({ ...confirmDialog, open: false });
  };

  // Handle confirm update
  const handleConfirmUpdate = async () => {
    setConfirmDialog({ ...confirmDialog, open: false });
    await performUpdate();
  };

  // Actual update function
  const performUpdate = async () => {
    try {
      setLoading((prev) => ({ ...prev, updating: true }));

      if (!id) {
        setSnackbar({
          open: true,
          message: "User ID not found in URL",
          color: "error",
        });
        return;
      }

      const formDataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        if (["photo", "cv"].includes(key)) return;

        if (key === "shifts") {
          if (isMultiShift) {
            if (Array.isArray(formData.shifts) && formData.shifts.length > 0) {
              formData.shifts.forEach((shiftId) => {
                formDataToSend.append("shift_ids[]", shiftId);
              });
            }
          } else if (formData.shift_id) {
            formDataToSend.append("shift_id", formData.shift_id);
          }
        } else if (formData[key] !== null && formData[key] !== undefined) {
          formDataToSend.append(key, formData[key]);
        }
      });


      // Handle role_id as array
      if (formData.role_id) {
        formDataToSend.append("roles[]", formData.role_id);
      }

      // Handle file fields
      const handleFileField = (fieldName, value) => {
        if (value instanceof File) {
          formDataToSend.append(fieldName, value);
        } else if (typeof value === "string" && value) {
          formDataToSend.append(fieldName, value);
        }
      };

      handleFileField("photo", formData.photo);
      handleFileField("resume", formData.cv);

      // Send request
      const response = await axios.post(`${API_URL}/users/basic-info/${id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (onUpdate) onUpdate(response.data);

      setSnackbar({
        open: true,
        message: response.data.message || "Profile updated successfully!",
        color: "success",
      });
    } catch (error) {
      console.error("Update error:", error);

      setSnackbar({
        open: true,
        message: getApiErrorMessage(error, "Failed to update profile"),
        color: "error",
      });
    } finally {
      setLoading((prev) => ({ ...prev, updating: false }));
    }
  };

  // Enhanced File Preview Component with specific icons
  const FilePreview = ({ file, fallbackUrl, expectedType = null, alt = "File Preview" }) => {
    const url = getFileUrl(file) || fallbackUrl;
    const fileName = getFileName(file, fallbackUrl);
    const fileDetails = getFileTypeDetails(file || fallbackUrl);
    const IconComponent = fileDetails.icon;

    // If no file is uploaded
    if (!url) {
      return (
        <div className="text-center text-muted">
          <InsertDriveFileIcon style={{ fontSize: 60, color: "#bdbdbd" }} />
          <div className="mt-2" style={{ fontSize: "12px" }}>
            No file uploaded
          </div>
        </div>
      );
    }

    // For images, show thumbnail
    if (fileDetails.type === "image") {
      return (
        <div className="text-center">
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            <img
              src={url}
              alt={alt}
              className="img-fluid rounded"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                border: "1px solid #ddd",
                cursor: "pointer",
              }}
            />
            <div className="mt-2 d-flex align-items-center justify-content-center">
              <IconComponent style={{ fontSize: 16, color: fileDetails.color, marginRight: 4 }} />
              {/* <div style={{ fontSize: '12px', wordBreak: 'break-word', maxWidth: '100px' }}>
                {fileName}
              </div> */}
            </div>
            <div className="text-primary" style={{ fontSize: "11px" }}>
              Click to view image
            </div>
          </a>
        </div>
      );
    }

    // For all other file types, show icon
    return (
      <div className="text-center">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-none d-block"
        >
          <div
            style={{
              display: "inline-block",
              padding: "16px",
              borderRadius: "8px",
              backgroundColor: `${fileDetails.color}15`,
              border: `1px solid ${fileDetails.color}30`,
            }}
          >
            <IconComponent style={{ fontSize: 48, color: fileDetails.color }} />
          </div>
          <div className="mt-2 d-flex flex-column align-items-center">
            <div style={{ fontSize: "11px", color: fileDetails.color, fontWeight: "bold" }}>
              {fileDetails.label}
            </div>
            <div
              style={{
                fontSize: "11px",
                wordBreak: "break-word",
                maxWidth: "120px",
                marginTop: "4px",
              }}
            >
              {/* {fileName} */}
            </div>
          </div>
          <div className="text-primary" style={{ fontSize: "11px", marginTop: "4px" }}>
            Click to {fileDetails.type === "pdf" ? "view" : "download"} file
          </div>
        </a>
      </div>
    );
  };

  if (!canSection) {
    return null;
  }

  return (
    <div>
      <Card>
        <SoftBox p={3}>
          <SoftTypography variant="h5">Basic Info</SoftTypography>
        </SoftBox>
        <SoftBox component="form" className="px-3">
          {/* ... (All your form fields remain exactly the same until Document Uploads section) */}

          {/* Personal Information */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("Name") && (
                <FormField
                  label="First Name"
                  placeholder="Alec"
                  value={formData.name}
                  onChange={handleInputChange("name")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("LastName") && (
                <FormField
                  label="Last Name"
                  placeholder="Thompson"
                  value={formData.last_name}
                  onChange={handleInputChange("last_name")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("DateOfBirth") && (
                <FormField
                  type="date"
                  label="DOB"
                  value={formData.dob}
                  onChange={handleInputChange("dob")}
                />
              )}
            </div>
          </div>
          {/* Personal Details */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("Gender") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Gender
                  </SoftTypography>
                  <SoftSelect
                    style={{ width: "100%" }}
                    placeholder="Select"
                    options={selectData.gender}
                    onChange={handleSelectChange("gender")}
                    value={selectData.gender.find((opt) => opt.value === formData.gender) || ""}
                  />
                </>
              )}
            </div>

            <div className="col-md-4">
              {canView("ReadyToRelocate") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Ready to Relocate
                  </SoftTypography>
                  <SoftSelect
                    placeholder="Select"
                    options={selectData.relocate}
                    onChange={handleSelectChange("relocate")}
                    value={selectData.relocate.find((opt) => opt.value === formData.relocate) || ""}
                  />
                </>
              )}
            </div>
            <div className="col-md-4">
              {canView("EmploymentStatus") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Employment Status
                  </SoftTypography>
                  <SoftSelect
                    placeholder="Select"
                    options={selectData.employementStatus}
                    onChange={handleSelectChange("employment_status")}
                    value={
                      selectData.employementStatus.find(
                        (opt) => opt.value === formData.employment_status
                      ) || ""
                    }
                  />
                </>
              )}
            </div>
          </div>

          {/* Contact Information */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("Email") && (
                <>
                  <FormField
                    label="Email"
                    value={formData.email}
                    onChange={handleInputChange("email")}
                    readOnly
                  />

                  {emailError && (
                    <SoftTypography variant="caption" color="error" mt={0.5}>
                      {emailError}
                    </SoftTypography>
                  )}
                </>
              )}
            </div>
            <div className="col-md-4">
              {canView("PhoneNumber") && (
                <FormField
                  label="Phone Number"
                  placeholder="+91 9876543210"
                  value={formData.phone_number}
                  onChange={handleInputChange("phone_number")}
                  inputProps={{
                    type: "tel",
                    inputMode: "numeric",
                    maxLength: 10,
                  }}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("EmergencyContact1") && (
                <FormField
                  label="Emergency Contact 1"
                  placeholder="+91 9876543210"
                  value={formData.emergency_contact_one}
                  onChange={handleInputChange("emergency_contact_one")}
                  inputProps={{
                    type: "tel",
                    inputMode: "numeric",
                    maxLength: 10,
                  }}
                />
              )}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("EmergencyContact2") && (
                <FormField
                  label="Emergency Contact 2"
                  placeholder="+91 9876543210"
                  value={formData.emergency_contact_two}
                  onChange={handleInputChange("emergency_contact_two")}
                  inputProps={{
                    type: "tel",
                    inputMode: "numeric",
                    maxLength: 10,
                  }}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("Location") && (
                <FormField
                  label="Location"
                  value={formData.location}
                  onChange={handleInputChange("location")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("CurrentAddress") && (
                <FormField
                  label="Current Address"
                  value={formData.current_address}
                  onChange={handleInputChange("current_address")}
                />
              )}
            </div>
          </div>

          {/* Address and Identification */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("PermanentAddress") && (
                <FormField
                  label="Permanent Address"
                  value={formData.permanent_address}
                  onChange={handleInputChange("permanent_address")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("Aadhar") && (
                <FormField
                  label="Aadhar Number"
                  value={formData.aadhar_number}
                  onChange={handleInputChange("aadhar_number")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("PAN") && (
                <FormField
                  label="PAN Number"
                  value={formData.pan_number}
                  onChange={handleInputChange("pan_number")}
                />
              )}
            </div>
          </div>

          {/* Employment Preferences */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("Referral") && (
                <FormField
                  label="Referral Source"
                  value={formData.referrer_name}
                  onChange={handleInputChange("referrer_name")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("Qualification") && (
                <FormField
                  label="Education Qualification"
                  value={formData.qualification}
                  onChange={handleInputChange("qualification")}
                />
              )}
            </div>
            <div className="col-md-2">
              {/* PF */}
              {true && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    PF
                  </SoftTypography>
                  <SoftSelect
                    placeholder="Select"
                    options={booleanOptions}
                    onChange={(opt) =>
                      setFormData((prev) => ({ ...prev, pf: opt?.value ?? false }))
                    }
                    value={booleanOptions.find((o) => o.value === formData.pf) || ""}
                  />
                </>
              )}
            </div>

            {/* ESI */}
            <div className="col-md-2">
              {true && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold" mt={1}>
                    ESI
                  </SoftTypography>
                  <SoftSelect
                    placeholder="Select"
                    options={booleanOptions}
                    onChange={(opt) =>
                      setFormData((prev) => ({ ...prev, esi: opt?.value ?? false }))
                    }
                    value={booleanOptions.find((o) => o.value === formData.esi) || ""}
                  />
                </>
              )}
            </div>
          </div>

          {/* Role and Branch Information */}
          {/* <div className="row mb-3">
            <div className="col-md-4">
              {canView("Role") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Role
                  </SoftTypography>
                  <SoftSelect
                    isRequired="true"
                    placeholder="Select"
                    options={dropdowns.roles}
                    onChange={handleSelectChange("role_id")}
                    value={dropdowns.roles.find((opt) => opt.value === formData.role_id) || ""}
                  />
                </>
              )}
            </div>
            <div className="col-md-4">
              {canView("Branch") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Branch
                  </SoftTypography>
                  <SoftSelect
                    isRequired="true"
                    placeholder="Select"
                    options={dropdowns.branches}
                    onChange={handleSelectChange("branch_id")}
                    value={dropdowns.branches.find((opt) => opt.value === formData.branch_id) || ""}
                  />
                </>
              )}
            </div>
            <div className="col-md-4">
              {canView("Shift") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    {isMultiShift ? "Shifts (Select Multiple)" : "Shift"}
                  </SoftTypography>
                  {loading.branch ? (
                    <SoftTypography variant="body2">Loading shifts...</SoftTypography>
                  ) : isMultiShift ? (
                    <SoftSelect
                      placeholder="Select shifts"
                      options={dropdowns.branchShifts}
                      onChange={handleMultiSelectChange("shifts")}
                      value={dropdowns.branchShifts.filter((opt) =>
                        formData.shifts?.includes(opt.value)
                      )}
                      isMulti
                    />
                  ) : (
                    <SoftSelect
                      placeholder="Select shift"
                      options={dropdowns.branchShifts}
                      onChange={handleSelectChange("shift_id")}
                      value={
                        dropdowns.branchShifts.find((opt) => opt.value === formData.shift_id) || ""
                      }
                    />
                  )}
                </>
              )}
            </div>
          </div> */}

          <div className="row mb-3">

            {/* ROLE */}
            <div className="col-md-3">
              {canView("Role") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Role
                  </SoftTypography>
                  <SoftSelect
                    isRequired="true"
                    placeholder="Select"
                    options={dropdowns.roles}
                    onChange={handleSelectChange("role_id")}
                    value={dropdowns.roles.find((opt) => opt.value === formData.role_id) || ""}
                  />
                </>
              )}
            </div>

            {/* BRANCH */}
            <div className="col-md-3">
              {canView("Branch") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Branch
                  </SoftTypography>
                  <SoftSelect
                    isRequired="true"
                    placeholder="Select"
                    options={dropdowns.branches}
                    onChange={(opt) => {
                      setFormData((prev) => ({
                        ...prev,
                        branch_id: opt?.value || "",
                        subbranch_id: "",   // ✅ reset
                        shift_id: null,     // ✅ reset
                      }));
                    }}
                    value={dropdowns.branches.find((opt) => opt.value === formData.branch_id) || ""}
                  />
                </>
              )}
            </div>

            {/* SUB BRANCH */}
            <div className="col-md-3">
              {canView("SubBranch") && (   // ✅ permission add
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Sub Branch
                  </SoftTypography>
                  <SoftSelect
                    placeholder="Select"
                    options={dropdowns.subBranches}
                    onChange={(opt) => {
                      setFormData((prev) => ({
                        ...prev,
                        subbranch_id: opt?.value || "",
                        shift_id: null, // reset shift
                      }));
                    }}
                    value={
                      dropdowns.subBranches.find((opt) => opt.value === formData.subbranch_id) || ""
                    }
                    isDisabled={!formData.branch_id}
                  />
                </>
              )}
            </div>

            {/* SHIFT */}
            <div className="col-md-3">
              {canView("Shift") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    {isMultiShift ? "Shifts (Select Multiple)" : "Shift"}
                  </SoftTypography>

                  {loading.branch ? (
                    <SoftTypography variant="body2">Loading shifts...</SoftTypography>
                  ) : isMultiShift ? (
                    <SoftSelect
                      placeholder="Select shifts"
                      options={dropdowns.branchShifts}
                      onChange={handleMultiSelectChange("shifts")}
                      value={dropdowns.branchShifts.filter((opt) =>
                        formData.shifts?.includes(opt.value)
                      )}
                      isMulti
                      isDisabled={!formData.subbranch_id}   // ✅ IMPORTANT
                    />
                  ) : (
                    <SoftSelect
                      placeholder="Select shift"
                      options={dropdowns.branchShifts}
                      onChange={handleSelectChange("shift_id")}
                      value={
                        dropdowns.branchShifts.find(
                          (opt) => Number(opt.value) === Number(formData.shift_id)
                        ) || ""
                      }
                      isDisabled={!formData.subbranch_id}   // ✅ IMPORTANT
                    />
                  )}
                </>
              )}
            </div>
          </div>

          {/* Manager and Team Leader */}
          {(selectedRole === "user" || selectedRole === "team leader") && (
            <div className="row mb-3">
              <div className="col-md-4">
                {canView("Manager") && (
                  <>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Manager
                    </SoftTypography>
                    <SoftSelect
                      placeholder={loading.branch ? "Loading..." : "Select"}
                      options={dropdowns.branchManagers}
                      onChange={handleSelectChange("manager_id")}
                      // value={
                      //   dropdowns.branchManagers.find((opt) => opt.value === formData.manager_id) ||
                      //   ""
                      // }
                      value={
                        dropdowns.branchManagers.find(
                          (opt) => Number(opt.value) === Number(formData.manager_id)
                        ) || ""
                      }
                      isDisabled={loading.branch}
                    />
                  </>
                )}
              </div>
              <div className="col-md-4">
                {canView("TeamLeader") && (
                  <>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Team Leader
                    </SoftTypography>
                    <SoftSelect
                      placeholder={loading.teamLeaders ? "Loading..." : "Select"}
                      options={dropdowns.teamLeaders}
                      onChange={handleSelectChange("team_leader_id")}
                      value={
                        dropdowns.teamLeaders.find(
                          (opt) => Number(opt.value) === Number(formData.team_leader_id)
                        ) || ""
                      }
                      isDisabled={loading.teamLeaders}
                    />
                  </>
                )}
              </div>
              <div className="col-md-4">
                {canView("Department") && (
                  <>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Department
                    </SoftTypography>
                    <SoftSelect
                      placeholder="Select"
                      options={dropdowns.department}
                      onChange={handleSelectChange("department_id")}
                      value={
                        dropdowns.department.find((opt) => opt.value === formData.department_id) ||
                        ""
                      }
                    />
                  </>
                )}
              </div>
            </div>
          )}

          {/* Department and Designation */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("Designation") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Designation
                  </SoftTypography>
                  <SoftSelect
                    placeholder="Select"
                    options={dropdowns.designation}
                    onChange={handleSelectChange("designation_id")}
                    value={
                      dropdowns.designation.find((opt) => opt.value === formData.designation_id) ||
                      ""
                    }
                  />
                </>
              )}
            </div>
            <div className="col-md-4">
              {canView("WorkExperienceYears") && (
                <FormField
                  label="Work Experience (Years)"
                  value={formData.exp_years}
                  onChange={handleExperienceChange("exp_years")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("WorkExperienceMonths") && (
                <FormField
                  label="Work Experience (Months)"
                  value={formData.exp_months}
                  onChange={handleExperienceChange("exp_months")}
                />
              )}
            </div>
          </div>

          {/* Salary and Notice Period */}
          <div className="row mb-3">
            <div className="col-md-4">
              {canView("NoticePeriod") && (
                <FormField
                  label="Notice Period"
                  value={formData.notice_period}
                  onChange={handleInputChange("notice_period")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("CurrentSalary") && (
                <FormField
                  label="Current Salary"
                  value={formData.salary_current}
                  onChange={handleInputChange("salary_current")}
                />
              )}
            </div>
            <div className="col-md-4">
              {canView("ExpectedSalary") && (
                <FormField
                  label="Expected Salary"
                  value={formData.salary_expected}
                  onChange={handleInputChange("salary_expected")}
                />
              )}
            </div>
          </div>

          {/* Document Uploads */}
          <div className="row mb-3" style={{ diplay: "flex", alignItems: "baseline" }}>
            <div className="col-md-4">
              {canView("EmployeeCode") && (
                <FormField
                  label="Employee Code"
                  placeholder="Employee Code"
                  value={formData.user_code}
                  onChange={handleInputChange("user_code")}
                  readOnly
                />
              )}
            </div>

            {/* CV Upload Section */}
            <div className="col-md-4">
              {canView("UploadCV") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Upload your CV/Resume
                  </SoftTypography>
                  <div
                    style={{
                      marginBottom: "16px",
                      minHeight: "140px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FilePreview
                      file={formData.resume}
                      fallbackUrl={formData.resume}
                      expectedType="document"
                      alt="CV Preview"
                    />
                  </div>
                  <UploadButton
                    onFileSelect={handleFileChange("resume")}
                    fileName={getFileName(formData.resume, formData.resume)}
                    accept=".pdf,.doc,.docx,.txt,.rtf"
                  />
                  <div className="mt-1" style={{ fontSize: "11px", color: "#666" }}>
                    <span style={{ fontWeight: "bold" }}>Supported formats:</span> PDF, DOC, DOCX,
                    TXT, RTF
                  </div>
                  <div
                    className="mt-1 d-flex flex-wrap"
                    style={{ fontSize: "10px", color: "#888", gap: "8px" }}
                  >
                    <div className="d-flex align-items-center">
                      <PictureAsPdfIcon
                        style={{ fontSize: 12, color: "#d32f2f", marginRight: 2 }}
                      />
                      <span>PDF</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <ArticleIcon style={{ fontSize: 12, color: "#2b579a", marginRight: 2 }} />
                      <span>Word</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <TextSnippetIcon style={{ fontSize: 12, color: "#4caf50", marginRight: 2 }} />
                      <span>TXT</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <DescriptionIcon style={{ fontSize: 12, color: "#ff9800", marginRight: 2 }} />
                      <span>RTF</span>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Photo Upload Section */}
            <div className="col-md-4">
              {canView("UploadPassportPhoto") && (
                <>
                  <SoftTypography variant="caption" fontWeight="bold">
                    Upload your Passport size photo
                  </SoftTypography>
                  <div
                    style={{
                      marginBottom: "16px",
                      minHeight: "140px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FilePreview
                      file={formData.photo}
                      fallbackUrl={formData.photo_url}
                      expectedType="image"
                      alt="Passport Photo"
                    />
                  </div>
                  <UploadButton
                    onFileSelect={handleFileChange("photo")}
                    fileName={getFileName(formData.photo, formData.photo_url)}
                    accept="image/*"
                  />
                  <div className="mt-1" style={{ fontSize: "11px", color: "#666" }}>
                    <span style={{ fontWeight: "bold" }}>Supported formats:</span> JPG, PNG, GIF,
                    WEBP, BMP, SVG
                  </div>
                  <div className="mt-1" style={{ fontSize: "10px", color: "#888" }}>
                    <div className="d-flex align-items-center">
                      <ImageIcon style={{ fontSize: 12, color: "#9c27b0", marginRight: 4 }} />
                      <span>Image files only</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {requiredErrors.length > 0 && (
            <div
              style={{
                background: "#fff4f4",
                border: "1px solid #f5c2c7",
                color: "#842029",
                padding: "10px 14px",
                borderRadius: "6px",
                marginBottom: "12px",
                fontSize: "13px",
              }}
            >
              <strong>Please fill the following required fields:</strong>
              <ul style={{ margin: "6px 0 0 18px" }}>
                {requiredErrors.map((field, index) => (
                  <li key={index}>{field}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Update Button */}
          <div className="row">
            <div className="col-md-12 d-flex justify-content-end mt-2">
              <SoftBox p={1}>
                {canView("Save") && (
                  <SoftButton
                    variant="gradient"
                    color="info"
                    size="medium"
                    onClick={showConfirmationDialog}
                    disabled={loading.updating || !value.is_basicinfo}
                  >
                    {loading.updating ? "Saving..." : "Save"}
                  </SoftButton>
                )}
              </SoftBox>
            </div>
          </div>
        </SoftBox>
      </Card>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCancelUpdate}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <DialogTitle id="confirmation-dialog-title">{confirmDialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmation-dialog-description">
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SoftButton
            onClick={handleCancelUpdate}
            color="secondary"
            variant="outlined"
            size="small"
          >
            Cancel
          </SoftButton>
          <SoftButton
            onClick={handleConfirmUpdate}
            color="info"
            variant="gradient"
            size="small"
            autoFocus
            disabled={loading.updating}
          >
            {loading.updating ? "Updating..." : "Confirm Update"}
          </SoftButton>
        </DialogActions>
      </Dialog>

      {/* Snackbar Notification */}
      <SoftSnackbar
        color={snackbar.color}
        icon="notifications"
        title="Notification"
        content={snackbar.message}
        open={snackbar.open}
        close={() => setSnackbar({ ...snackbar, open: false })}
        time={3000}
      />
    </div>
  );
}

BasicInfo.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BasicInfo;
